import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchIsZoomEnabled, getIsZoomEnabled } from '~/store/duck/conferencing'
import { getCurrentBusinessId } from '~/store/reducers/auth'

export const useGetIsZoomEnabled = () => {
  const dispatch = useDispatch()

  const isZoomEnabled = useSelector(getIsZoomEnabled)
  const currentBusinessId = useSelector(getCurrentBusinessId)
  useEffect(() => {
    if (currentBusinessId) {
      dispatch(fetchIsZoomEnabled(currentBusinessId))
    }
  }, [currentBusinessId])

  return isZoomEnabled
}
